<template>
  <div class="content">
    <div class="row animated fadeIn">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body mt-0 pt-0">
            <div class="row">
              <h4 class="card-title ml-5">
                Reports
              </h4>
            </div>
            <div v-if="whoCanAccess.includes(user.email)" class="row">
              <div class="col-md-4">
                <div class="form-group mt-5">
                  Key:
                  <textarea v-model="key" class="form-control" cols="30" rows="1">
                  </textarea>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mt-5">
                  Endpoint:
                  <textarea v-model="endpoint" class="form-control" cols="30" rows="1">
                  </textarea>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mt-5">
                  Description:
                  <textarea v-model="description" class="form-control" cols="30" rows="1">
                  </textarea>
                </div>
              </div>
              <div class="col-md-2">
                <button :disabled="loading" @click="saveNewReport" class="btn btn-primary mt-25">Save</button>
              </div>
            </div>

            </div>
          <div v-if="gLoader" class="loader small_loader"></div>
            <table v-else class="table table-striped table-bordered">
              <thead>
              <tr>
                <th class="text-center">Name</th>
                <th class="text-center">Description</th>
                <th class="text-center">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, index) in reportsList" :key="index">
                <td>{{ row.key }}</td>
                <td>
                  {{row.description}}
                </td>
                <td class="text-center">
                  <div>
                    <button :disabled="selectedIndex ===  index" @click="generateReport(row, index)" class="btn btn-primary btn-sm">
                      Generate report
                    </button>
                    <button v-if="row.reportGenerating" class="btn btn-primary btn-sm ml-2"><i class="fa fa-spinner fa-spin"></i></button>
                    <button v-else-if="row.url" @click="download(row.url)" class="btn btn-primary btn-sm ml-2"><i class="fa fa-download"></i></button>
                  </div>

                  <small class="mt-10">Last created: {{formattedDate(row.lastCreatedAt)}}</small>
                </td>
              </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from "sweetalert2"
import dateMixin from "@/mixins/dateMixin";
export default {
  name: "reports",
  mixins: [dateMixin],
  data () {
    return {
      whoCanAccess: ['salman.yousaf@septemsystems.com', 'wpo-septem-admin@septemsystems.com', 'sara@bigscoots.com'], // only these emails can add reports
      description: '',
      key: '',
      endpoint: '',
      reportsList: [],
      loading: false,
      gLoader: false,
      selectedIndex: -1
    }
  },
  mounted() {
    console.log('in reports mounted')
    this.fetchAllReports()
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    download (url) {
      window.open(url, '_self');
    },
    async generateReport(row, index){
      try {
        console.log('row', row)
        this.selectedIndex = index;
        switch (row.key) {
          case 'Collaborator':
          {
            await this.$reportService.post('reports/collaborator', {})
            break;
          }
          case 'Accounts':
          {
            await db.collection('savedReports').doc(row.id).update({ reportGenerating: true})
            await this.$patchStackService.post(row.endpoint, {
              grant_type: 'token'
            });
            break;
          }
          default:
            // code to execute if expression does not match any of the cases
            break;
        }
        this.loading = false
        swal({
          title: "Success",
          text: `${row.key} Report has been initiated to generate.`,
          type: "success",
        });
      }
      catch(err){
        console.log(err.toString())
        this.loading=false
        swal({
          title: "Error",
          text: "Error while generating report" ,
          type: "error",
        });
      } finally {
        this.selectedIndex = -1;
      }
    },

    async fetchAllReports () {
      try {
        this.reportsList = [];
        this.gLoader = false; // gLoader means loader for getting reports
        const reportsRef = await db.collection('savedReports').get();
        if (reportsRef.size) {
          reportsRef.forEach(el => {
            this.reportsList.push({ id: el.id, ...el.data() })
          })
        }
      } catch (e) {
        console.log('Something went wrong while getting reports')
      } finally {
        this.gLoader = false;
      }
    },
    // this func is only for collaborators
    async saveNewReport() {
      try {
        this.loading = true
        await db.collection('savedReports').add({
          description: this.description,
          key: this.key,
          endpoint: this.endpoint || '',
          createdDate: new Date().toISOString()
        })
        swal('Success', 'You have successfully added new report!', 'success')
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Something went wrong while adding new report!', 'error')
      } finally {
        this.loading = false;
        this.description = '';
        this.key = '';
      }
    }
  }
}
</script>

<style scoped>
.table small {
  font-weight: 500;
}
</style>